import Fetch from "./Fetch";
import FetchWithSiteId from "./FetchWithSiteId";

import { API_BASIC_URL_POLYGON_SERVICE, API_BASIC_URL_SLOT_SERVICE } from "../config/constants";
import { handleError, handleResponse, handleXLSXResponse } from "./ApiUtils";

export const fetchPosZoneServiceTypeList = (data) => {
  return Fetch.get(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/delivery-bag/pos-zone-service-mapping`, data).then(handleResponse).catch(handleError);
};

export const fetchPolygonServiceRecordnBasedOnCountryId = (data) => {
  return FetchWithSiteId.create(`${API_BASIC_URL_POLYGON_SERVICE}/api/v2/polygon-mapping/filter`, data.data).then(handleResponse).catch(handleError);
};

export const updatePolygonServiceRecordnByPayload = (data) => {
  return Fetch.create(`${API_BASIC_URL_POLYGON_SERVICE}/api/v1/polygon/${data.polygonId}`, data).then(handleResponse).catch(handleError);
};

export const fetchMappedPosZoneListBasedOnServiceTypeAndCountry = (data) => {
  return Fetch.get(`${API_BASIC_URL_POLYGON_SERVICE}/api/v1/polygon-mappings/serviceType/${data.serviceType}/${data.countryName}`).then(handleResponse).catch(handleError);
};

export const fetchPolygonDetailsHistoryBasedOnIdServiceTypeAndCountry = (data) => {
  return Fetch.create(`${API_BASIC_URL_POLYGON_SERVICE}/api/v1/audit/polygons`, data).then(handleResponse).catch(handleError);
};

export const fetchExportToExcel = (data) => {
  return FetchWithSiteId.exportRequest(`${API_BASIC_URL_POLYGON_SERVICE}/api/v3/polygon-mapping/download`, undefined, "arraybuffer").then(handleXLSXResponse).catch(handleError);
};

export const fetchPolygonServiceMapRecordnBasedOnBoundaries = (data) => {
  return FetchWithSiteId.create(`${API_BASIC_URL_POLYGON_SERVICE}/api/v2/polygon-mapping/boundaries`, data).then(handleResponse).catch(handleError);
};

export const fetchPosZoneRecordPositionDetails = (data) => {
  return FetchWithSiteId.create(`${API_BASIC_URL_SLOT_SERVICE}/api/v1/pos/country`, data).then(handleResponse).catch(handleError);
};

export const getAllPolygonIdsDetails = () => {
  return FetchWithSiteId.get(`${API_BASIC_URL_POLYGON_SERVICE}/api/v1/polygons/ids`).then(handleResponse).catch(handleError);
};

export const createNewPolygonIdConfig = (data) => {
  return FetchWithSiteId.create(`${API_BASIC_URL_POLYGON_SERVICE}/api/v2/polygon-mapping`, data).then(handleResponse).catch(handleError);
};

export const fetchPolygonIdDetails = (polygonId) => {
  return FetchWithSiteId.get(`${API_BASIC_URL_POLYGON_SERVICE}/api/v2/polygon-mapping?polygonId=${polygonId}`).then(handleResponse).catch(handleError);
};

export const updatePolygonIdConfig = (data) => {
  return FetchWithSiteId.update(`${API_BASIC_URL_POLYGON_SERVICE}/api/v2/polygon-mapping`, data).then(handleResponse).catch(handleError);
};
